import { call, put, takeLatest } from 'redux-saga/effects';
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from '../../../api';
import {
    FETCH_SEUIL_PASSAGE_REQUEST,
    fetchSeuilPassageSuccess,
    fetchSeuilPassageFailure,
    CREATE_SEUIL_PASSAGE_REQUEST,
    createSeuilPassageSuccess,
    createSeuilPassageFailure,
    UPDATE_SEUIL_PASSAGE_REQUEST,
    updateSeuilPassageSuccess,
    updateSeuilPassageFailure,
    DELETE_SEUIL_PASSAGE_REQUEST,
    deleteSeuilPassageSuccess,
    deleteSeuilPassageFailure
} from '../actions/seuilPassageActions';

function* fetchSeuilsSaga(action) {
    const token = sessionStorage.getItem("token");
    try {
        const response = yield call(getRequest, {
            url: `${API_BASE_URL}/api/seuils-passage/company/${action.companyId}`,
            token
        });
        yield put(fetchSeuilPassageSuccess(response.data));
    } catch (error) {
        yield put(fetchSeuilPassageFailure(error.response?.data?.message || error.message));
    }
}

function* createSeuilSaga(action) {
    const token = sessionStorage.getItem("token");
    try {
        const response = yield call(postRequest, {
            url: `${API_BASE_URL}/api/seuils-passage`,
            data: action.payload,
            token
        });
        yield put(createSeuilPassageSuccess(response.data));
    } catch (error) {
        yield put(createSeuilPassageFailure(error.response?.data?.message || error.message));
    }
}

function* updateSeuilSaga(action) {
    const token = sessionStorage.getItem("token");
    try {
        const { id, seuilData } = action.payload;
        const response = yield call(putRequest, {
            url: `${API_BASE_URL}/api/seuils-passage/${id}`,
            data: seuilData,
            token
        });
        yield put(updateSeuilPassageSuccess(response.data));
    } catch (error) {
        yield put(updateSeuilPassageFailure(error.response?.data?.message || error.message));
    }
}

function* deleteSeuilSaga(action) {
    const token = sessionStorage.getItem("token");
    try {
        yield call(deleteRequest, {
            url: `${API_BASE_URL}/api/seuils-passage/${action.payload}`,
            token
        });
        yield put(deleteSeuilPassageSuccess(action.payload));
    } catch (error) {
        yield put(deleteSeuilPassageFailure(error.response?.data?.message || error.message));
    }
}

function* seuilPassageSaga() {
    yield takeLatest(FETCH_SEUIL_PASSAGE_REQUEST, fetchSeuilsSaga);
    yield takeLatest(CREATE_SEUIL_PASSAGE_REQUEST, createSeuilSaga);
    yield takeLatest(UPDATE_SEUIL_PASSAGE_REQUEST, updateSeuilSaga);
    yield takeLatest(DELETE_SEUIL_PASSAGE_REQUEST, deleteSeuilSaga);
}

export default seuilPassageSaga;
